// 定义action,作为dispatch的参数
export const actionType = {
  SAVE_USER: 'SAVE_USER',
  SAVE_FIRST_KEY: 'SAVE_FIRST_KEY',
  SAVE_SECOND_KEY: 'SAVE_SECOND_KEY',
}
